module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-13"
    }
  }, [_c('span', {
    staticClass: "Serif_Bold _idGenCharOverride-1"
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Opening"
  }, [_c('span', {
    staticClass: "_idGenDropcap-1"
  }, [_vm._v("D")]), _vm._v("anny had never seen anything like it. A box "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("ll of money. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ick bundles of used notes bound with "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("t rubber bands. Not pound notes, or "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("vers. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at would have been a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("onishing enough. But mo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" of these bricks of money were £100 notes, with a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("w £20 wads among them. It wa"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("s awesome.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("It was also terri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fy")]), _vm._v("ing. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was no innocent explanation "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r this. No interpretation that didn’t involve danger. His mouth dried, his tongue seeming to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ll "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("his mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He wanted to slam the box shut and run, to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rget what he’d seen and never be troubled again by its implications. And then his ambition kicked in, his reporter’s in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("inct trumping his m"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("isgivings.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" thing he had to do was "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("gure out how much money was in the box. Gingerly, as if it might disintegrate in his hands, he eased out a bundle of hundreds. He slipped the rubber band o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("nned them out. He’d never seen a £100 note be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re. If they hadn’t shown signs of wear and tear, he’d have taken them "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("rgeries.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He picked up a hand"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l and "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("udied them. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey were an assortment "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the three Scottish banks that had the right to issue notes. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e Royal Bank of Scotland, dark red, its watermark panel showing Adam Smith, a detailed line drawing of Balmoral on the back. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e Bank of Scotland, red and brown lines that looked like they’d been made by the Spirograph set he’d had as a kid. Sir Walter Scott gazing out at him; the view of the bank’s head o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffi")]), _vm._v("ce building "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om the Mound. And the Clydesdale, a scarlet drawing of Lord Kelvin on the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ont and an imposing university lecture theatre on the back. He held them to his nose and sni"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("d. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey smelled like money, that unmi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("akable mixture le"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" by hands and wallets, bodies "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("and smoke.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Next he counted the notes. A total of one hundred, making each bundle £10,000. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at was more than he’d paid "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("at. More than he’d earn in two years, be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re tax, including his expenses. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere were another eight bundles of hundreds in the box. And "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ve bundles of twenties, some English notes among them, St George slaying the dragon next to the queen’s head. A hundred grand, laid out b"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("re him.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("As he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ared at the cash, his brain "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("arted working again. "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Brian McGillivray – Jan – 100k – Meridian Flyer")]), _vm._v(". Was this McGillivray’s January payment "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a racehorse? Or something else? Either way he should take an"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("other pic.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere were no more answers in the drawer, nor in the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ling cabinets, which contained nothing more exciting than what appeared to Danny to be per"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("ctly normal client "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("les of insurance policies covering property and li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" assurance. Time to tidy up an"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("d get out.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("Getting through Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas Day had been tough. Trying to act casual around Joseph was a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ruggle "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r Danny. It was a giant "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ep "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om never quite tru"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ing his brother to acknowledging he was actively dishone"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(". And the next "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ep was how he would deal with that. Danny didn’t think he could walk away "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory that could make his career, a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory he could be proud of breaking. But what would it do to hi"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("s parents?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rced himself to join in the Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas rituals. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e exchange of presents – a new Marks and Spencer jumper "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om his parents, a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("ashy silk tie "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om Joseph – then cans of beer "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the men and a sweet sherry "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r his mother. Roa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" turkey dinner with enough le"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("overs to keep them going "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r a week. Clootie dumpling and cream, the old silver threepenny pieces his mother had hoarded wrapped in greaseproof paper "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("u"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ffe")]), _vm._v("d into the pudding to endanger the teeth of the unwary. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en A"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er Eight mints and the queen on the box. "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Gold")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("nger")]), _vm._v(", with local hero Sean Connery playing James Bond. Followed by "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("upid game show Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas specials that Marie laughed along to while the three men dozed in their chairs. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en the big "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("lm. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Th")])]), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("e Sting")]), _vm._v(", with Robert Red"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rd and Paul Newman. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory of the complicated con trick made Danny uncom"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rtable, and he couldn’t ignore the nagging reminder of Red"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rd in "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("All the President’s Men.")]), _vm._v(" Bob Woodward would know exactly what he needed t"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("o do next.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("As the titles rolled, he pushed himself out of the settee and groaned as he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("retched. ‘I’d better be getting back to Glasgow,’ "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("he sighed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I thought you were "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("aying, son?’ His mother lo"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("oked hurt.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘I’d love to, Mum, but I’m on the day shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" tomorrow, and the weather "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("reca"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" isn"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("’t great.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Be a good excuse "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r skiving, if you got snowed in,’ Josep"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("h drawled.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at’s no way to think,’ his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("ther said, almo"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ern. ‘Danny’s got responsibilities to his shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" mates. If he’s not there, somebody else has to pick up the slack, is that no’ ri"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ght, son?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Aye, Dad. And I’ll be back "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the New Year. No way am I miss"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ing that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("It took another quarter hour "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r him to escape, his mother insi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ing on packing up a turkey leg and a massive wedge of dumpling to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rti"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fy")]), _vm._v(" him in the coming days. But at la"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" he was on the road. He pushed his cassette of "), _c('span', {
    staticClass: "Serif_Italic _idGenCharOverride-2"
  }, [_vm._v("Power in the Darkness")]), _vm._v(" into the slot and turned up the volume, the punching beat of ‘"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("2")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("4")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("6")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("8")]), _vm._v(" Motorway’ driving everything else "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" his mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("Boxing Day was ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" like any other in the li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v(" of a daily newspaper. Next morning, Danny was due to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("art his shi"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" at ten, but he arrived an hour early and headed "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("raight "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the library. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e duty librarian looked up "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("om his break"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fast")]), _vm._v(", so "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("artled to see anyone in his domain at that time of day that he squeezed his bacon roll so hard the brown sauce oozed out and coated his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ngers. ‘Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(", Danny, you gave me a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("ight,’ he exclaimed. ‘Where’s "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("the ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("re?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Nothing to worry about, eat your roll. It’s not cuttings I’m a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("er, I ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" want to look something up o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" the re"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rence shelves. No need "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r you to get o"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")]), _vm._v(" your backside.’ Danny gave him a cheeky smile and carried on pa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" the grey metal shelves with their impenetrable "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ling sy"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("em that no reporter had ever been permitted to learn. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was no chance of the librarians being made redundant, not while they were the only ones who knew how to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nd whichever brown envelope was"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" required.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e re"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rence room was at the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("r end. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ree walls of books and a long table under the window with its unrivalled view of the car park and the brick wall beyond. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e shelves contained a collection of re"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("rence books that encompassed an a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("onishing range of subjects. From "), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("Jane’s Fighting Ships ")]), _vm._v("to the "), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("Michelin Red Guide: Great Britain and Ireland")]), _vm._v(" via "), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("Crock")]), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("fo")])]), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("rd’s Clerical Directory, Debrett’s Peerage and Baronetage ")]), _vm._v("and ten years’ worth of "), _c('span', {
    staticClass: "Serif_Italic CharOverride-6"
  }, [_vm._v("Whitaker’s Almanack.")]), _vm._v(" What Danny was looking "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r was on the bottom shelf – an unbroken line of "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fa")]), _vm._v("t spines in pa"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("el shades. Blue and grey, pink and coral, ochre and green, they encompassed the current phone directories "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the whole British Isles. He crawled along the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fl")]), _vm._v("oor till he "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("und what he was looking "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r and pulled out the volume that included So"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("uthampton.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny sat "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("cross")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("legged")]), _vm._v(" with the thick directory in his lap and looked up ‘Maclay’. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere were two entries in the residential section of the book. One was a James T. Maclay in Burgess Road. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e other was a W. J. Maclay, Applewood House, Applewood Lane, Hythe. Not "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("r the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" time, Danny wished phone books were illu"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("rated. It would be help"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l to see the houses attached to the addresses, ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" to give "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rewarning of the kind of person you were dealing with. It was a mad idea, he knew that. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("e books would have to be impossibly cumbersome, and they’d take "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rever t"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("o compile.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He moved on to the business section at the back of the book and turned the pages impatiently. Maclays didn’t ju"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" have a li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ing, they had a box advert across two columns. ‘MACLAYS, the premier boat broker on Southampton Water. Luxury cra"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(" speciali"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("s.’ Complete with a line drawing of a sleek "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("two")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ma")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ed")]), _vm._v(" yacht. And an address and two phon"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e numbers.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("What if the my"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("erious names on the paper weren’t racehorses? What if they were boats? Otherwise, what did a boatyard have to do with insurance? More to the point, what did it have to do with his brother? He needed Peter"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" McGovern.")])]), _vm._v(" "), _c('p', {
    staticClass: "BTSpace"
  }, [_vm._v("It was another two "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nail")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("biting")]), _vm._v(" days be"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("re the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nancial correspondent came back to work. Danny tracked him down to the pub in the early a"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v("ernoon and plonked a large whisky in "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("o"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("nt of him.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("McGovern tipped his glass in a salute. ‘A merry Chri"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("mas to you too. So, did you manage to make good use of the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fest")]), _vm._v("iv"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e season?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Danny hesitated. Was he giving too much to McGovern? Could he tru"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" him not to "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("double")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("cross")]), _vm._v(" him and punt the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ory as all his own work? It wouldn’t be the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("r"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(" time Danny had had his "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ngers burned by a "), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("so")]), _vm._v("-"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("called")]), _vm._v(" colleague. On the other hand, McGovern had been giving him use"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fu")]), _vm._v("l in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rmation, not keeping it to himself. And Danny was all at sea when it came to the "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nanc"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ial ")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("u")]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ff")])]), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("Reluctantly, he took out his notebook and opened it at the page where he’d made his notes. ‘I "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("und another li"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v(".’ He showed the page to"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v(" McGovern.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("He "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fr")]), _vm._v("owned. ‘Graeme Brown . . .‘ He held up a "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("nger to "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("op Danny interrupting. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("en he gave a satis"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ed smirk. ‘Launderettes. And some sugge"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("st")]), _vm._v("ion of drugs as well. You’d need to ask Wee Gordon Beattie about that. His cop contacts keep him current on the bottom "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fe")]), _vm._v("eders. So again, you’re looking at somebody who potentially might be in a position to evade th"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e taxman.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ere was a name on the other side of the paper,’ Danny said, mentally "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fi")]), _vm._v("ling away the new in"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("fo")]), _vm._v("rmation. ‘I did a bit of digging and I discovered Maclays of Southampton are boat brokers. "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("ey specialise in luxury cra"), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("ft")]), _vm._v(". "), _c('span', {
    staticClass: "HPh4_Highlighted_phrase_4"
  }, [_vm._v("Th")]), _vm._v("at’s maybe where these guys are spending the"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("ir money?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘Nice work,’ McGovern said slowly. ‘But it’s not much use to them out on the ocean wav"), _c('span', {
    staticClass: "HPh3_Highlighted_phrase_3"
  }, [_vm._v("e, is it?’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bc3ed60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802159038-12.vue
// module id = 99
// module chunks = 0